module.exports = __webpack_public_path__ + "img/edda0b57faac92a3899b307ba52c5fa7.png";